import { createHSNURL, mobileExistCheckUrl } from "../api";
import axios from "axios";
import { getHeader } from "@/helpers";

export function createHSN(requestData) {
  return axios({
    url: createHSNURL(),
    data: requestData,
    method: "POST",
    headers: getHeader(),
  });
}

export function MobileExistCheck(requestData) {
  return axios({
    url: mobileExistCheckUrl(),
    data: requestData,
    method: "POST",
    // headers: getHeader(),
  });
}
